const setUser = (user) => {
  return {
    type: 'SET_USER', payload: user,
  };
};

const deleteUser = () => {
  return {
    type: 'DELETE_USER',
  };
};

export {
  setUser, deleteUser,
};